(function (app) {

    app.constant("_investmentObjectives",
        [
            {
                Name: "TaxDeferredGrowth",
                DisplayName: "Tax-deferred growth",
            },
            {
                Name: "ProvidesGuarantee",
                DisplayName: "Provides guarantees",
            },
            {
                Name: "GrowthPotential",
                DisplayName: "Growth potential",
            },
            {
                Name: "PassToBeneficiary",
                DisplayName: "Pass to beneficiaries",
            },
            {
                Name: "GrowthFollowedByIncome",
                DisplayName: "Growth, followed by income",
            },
            {
                Name: "LifetimeIncome",
                DisplayName: "Lifetime income",
            },
            {
                Name: "ImmediateIncome",
                DisplayName: "Immediate income",
            },
            {
                Name: "DeferredIncome",
                DisplayName: "Deferred income",
            },
        ]);

})(window.app); //jshint ignore:line